import { render } from "./candidate-row.vue?vue&type=template&id=13af8100"
import script from "./candidate-row.vue?vue&type=script&lang=js"
export * from "./candidate-row.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__